import { sectionWrap, escapeHtml } from "./factories";

function getVideoThumbnail(url) {
  // YouTube
  const ytMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
  if (ytMatch) {
    return `https://img.youtube.com/vi/${ytMatch[1]}/hqdefault.jpg`;
  }
  // Vimeo — no thumbnail without API, use placeholder
  return "";
}

export function makeVideoEmbedBlock(videoUrl = "") {
  const thumbnail = videoUrl ? getVideoThumbnail(videoUrl) : "";
  const safeUrl = escapeHtml(videoUrl);

  const thumbnailImg = thumbnail
    ? `<img src="${escapeHtml(thumbnail)}" alt="Video thumbnail" style="width:100%;display:block;border-radius:10px;" />`
    : `<div style="width:100%;height:200px;background:rgba(0,0,0,0.06);border-radius:10px;display:flex;align-items:center;justify-content:center;color:rgba(0,0,0,0.3);font-size:13px;">Paste a YouTube or Vimeo URL</div>`;

  const content = videoUrl
    ? `<a href="${safeUrl}" target="_blank" rel="noopener noreferrer" style="display:block;position:relative;text-decoration:none;">
        ${thumbnailImg}
        <div style="
          position:absolute;
          top:50%;
          left:50%;
          transform:translate(-50%,-50%);
          width:56px;
          height:56px;
          border-radius:50%;
          background:rgba(0,0,0,0.7);
          display:flex;
          align-items:center;
          justify-content:center;
        ">
          <div style="
            width:0;
            height:0;
            border-top:10px solid transparent;
            border-bottom:10px solid transparent;
            border-left:16px solid #ffffff;
            margin-left:3px;
          "></div>
        </div>
      </a>`
    : thumbnailImg;

  return sectionWrap(
    `
    <div style="margin:18px 0;" data-video-embed data-video-url="${safeUrl}">
      ${content}
    </div>
    `,
    "video-embed"
  );
}
